module.exports = __webpack_public_path__ + "static/manual_of_golems-2f695a51d9b2f02e842230c13b100b03.png";